<template>
  <Accordion
      title="By Operating System"
      subtitle="What operating systems are being used?"
      :item-data="itemData"
  />
</template>

<script>

import Accordion from './Accordion.vue';

export default {
  name: 'AccordionOperatingSystem',
  components: {
    Accordion,
  },

  props: {
    itemData: {
      type: Array,
      default() {
        return ([]);
      },
    },
  },
};
</script>
